<template>
  <div class="page-wrapper">
    <HeaderComponent />

    <div class="page-content">
      <AppBreadcrumb :items="[{ label: 'Bosh sahifa' }]" />

      <div class="categories-container">
        <div class="categories-grid">
          <div v-for="item in categories" :key="item.title" class="category-item">
            <CategoryCard
              :title="item.title"
              :description="item.description"
              :to="item.to"
              :icon="item.icon"
              :badge="item.badge"
              :badge-color="item.badgeColor"
              :disabled="item.disabled"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent.vue'
import AppBreadcrumb from '../components/AppBreadcrumb.vue'
import CategoryCard from '../components/CategoryCard.vue'

export default {
  components: {
    HeaderComponent,
    AppBreadcrumb,
    CategoryCard
  },
  data() {
    return {
      categories: [
        { 
          title: 'Real imtihon', 
          description: 'Asosiy imtihon rejimi', 
          to: '/real-exam', 
          icon: '📝' 
        },
        { 
          title: '10 ta biletlar', 
          description: '10 talik test biletlari', 
          to: '/tickets/10', 
          icon: '🔟' 
        },
        { 
          title: '20 tali biletlar', 
          description: '20 talik test biletlari', 
          to: '/tickets/20', 
          icon: '📚' 
        },
        { 
          title: '50 tali biletlar', 
          description: '50 talik test biletlari', 
          to: '/tickets/50', 
          icon: '🎯' 
        },
        { 
          title: 'Xato belgilagan savollarim', 
          description: 'Xato ishlangan savollar', 
          to: '/wrong-questions', 
          icon: '❌' 
        },
        { 
          title: 'Jarima ballari', 
          description: 'Jarima ballari', 
          to: '/fine-points', 
          icon: '⚠️' 
        },
        { 
          title: 'Tibbiyot ma’lumotlari', 
          description: 'Tibbiy bilimlar', 
          to: '/medical-info', 
          icon: '🏥',
          badge: 'Jarayonda',
          badgeColor: 'orange',
          disabled: true
        },
        { 
          title: 'Yo‘l belgilari', 
          description: 'Yo‘l belgilari katalogi', 
          to: '/road-signs', 
          icon: '🚸',
          badge: 'Jarayonda',
          badgeColor: 'orange',
          disabled: true
        },
        { 
          title: 'Jarimalar', 
          description: 'Jarimalar ro‘yxati', 
          to: '/fines', 
          icon: '💸',
          badge: 'Jarayonda',
          badgeColor: 'orange',
          disabled: true
        }
      ]
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg);
}

.page-content {
  flex: 1;
  padding: 0 24px 32px;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.categories-container {
  margin-top: 24px;
}

.categories-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.category-item {
  width: 100%;
}

/* Tablet (768px - 1024px) */
@media (max-width: 1024px) {
  .page-content {
    padding: 0 20px 28px;
  }
  
  .categories-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }
}

/* Mobile (576px - 768px) */
@media (max-width: 768px) {
  .page-content {
    padding: 0 16px 24px;
  }
  
  .categories-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
  }
}

/* Small Mobile (320px - 576px) */
@media (max-width: 576px) {
  .page-content {
    padding: 0 12px 20px;
  }
  
  .categories-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}
</style>